// import {matchHeight} from 'matchheight/dist/MatchHeight.js';

export default {
  init() {
    // JavaScript to be fired on the home page

    // function prodSlideWidth(){
    //   var browserWidth = $(window).width();
    //   if (browserWidth > 767) {
    //     var setWidth = $(".jobs-slider").width()/3;
    //     $("#job-slider li").width(setWidth*3);
    //     // console.log(setWidth);
    //     $("#job-slider .job-listing-content").width(setWidth);
    //   }else{
    //     setWidth = $(".jobs-slider").width()/1;
    //     $("#job-slider li").width(setWidth*1);
    //     // console.log(setWidth);
    //     $("#job-slider .job-listing-content").width(setWidth);
    //   }
    // }

    // function ctaBoxesAlign(){
    //   $(".section-features .feature-content-single").height('auto');
    //   var maxFeatExcerpt = Math.max.apply(Math, $(".section-features .feature-content-single").map(function() { return $(this).height(); }));
    //   $(".section-features .feature-content-single").each(function() {
    //     $(this).height(maxFeatExcerpt);
    //   });
    // }

    // function jobsHeadingBoxAlign(){
    //   $("#job-slider li a").height('auto');
    //   var maxFeatExcerpt = Math.max.apply(Math, $("#job-slider li a").map(function() { return $(this).height(); }));
    //   $("#job-slider li a").each(function() {
    //     $(this).height(maxFeatExcerpt);
    //   });
    // }

    // function jobsHeadingAlign(){
    //   $("#job-slider li a h2").height('auto');
    //   var maxFeatExcerpt = Math.max.apply(Math, $("#job-slider li a h2").map(function() { return $(this).height(); }));
    //   $("#job-slider li a h2").each(function() {
    //     $(this).height(maxFeatExcerpt);
    //   });
    // }

    $(window).load(function(){

      $('#hero-slider').flexslider({
        animation: "fade", //do not use slider
        slideshow: true,
      });

      // ctaBoxesAlign();
      // jobsHeadingAlign();
      // jobsHeadingBoxAlign();
      // prodSlideWidth();

      $('#job-slider').flexslider({
        animation: "slide",
        animationLoop: false,
        itemWidth: 350,
        itemMargin: 20,
        minItems: 1,
        maxItems: 3,
      });
    });

    // function jobExcerptAlign(){
    //   // $("#job-slider .job-listing-excerpt").height('auto');
    //   // var maxExcerpt = Math.max.apply(Math, $("#job-slider .job-listing-excerpt").map(function() { return $(this).height(); }));
    //   // $("#job-slider .job-listing-excerpt").each(function() {
    //   //     $(this).height(maxExcerpt);
    //   // });


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    $(window).load(function() {
      $(function() {
        $('#job-slider li a h2').matchHeight({byRow: false });
      });
    });

    $(document).load(function() {
      $(function() {
        $('#job-slider li a h2').matchHeight();
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js